// extracted by mini-css-extract-plugin
export var container = "_6l-0";
export var infoButton = "_6l-1";
export var label = "_6l-3";
export var labelExpanded = "_6l-4";
export var price = "_6l-5";
export var priceExpanded = "_6l-6";
export var title = "_6l-2";